import { render, staticRenderFns } from "./ProviderPerformanceBackfill.vue?vue&type=template&id=ad6f3656&"
import script from "./ProviderPerformanceBackfill.vue?vue&type=script&lang=js&"
export * from "./ProviderPerformanceBackfill.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPerformanceBackfill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports